export const ENVIRONMENT_DISPLAY: Record<
  string,
  { name: string; cssClass: string }
> = {
  Local: { name: 'Lokal', cssClass: 'environment-local' },
  Development: { name: 'Utveckling', cssClass: 'environment-development' },
  Systemtest: { name: 'Systemtest', cssClass: 'environment-systemtest' },
  Acceptanstest: {
    name: 'Acceptanstest',
    cssClass: 'environment-acceptanstest',
  },
  Utbildning: { name: 'Utbildning', cssClass: 'environment-utbildning' },
};
